import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, bookingTitle, fontWeightBold, marginBottom, linkText } from '../../../helpers/getEmailStyles';

class BookingConfirmationHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      threadId: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
      guestJoinedDate: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      guests: PropTypes.number.isRequired
    }).isRequired
  };

  render() {
    const { content: { reservationId, threadId, logo, siteName, listTitle } } = this.props;
    const { content: { guestName, guestProfilePic, guestJoinedDate, hostName } } = this.props;
    const { content: { checkIn, checkOut, guests } } = this.props;
    let checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '',
      checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';
    let itineraryURL;
    itineraryURL = url + '/users/trips/itinerary/' + reservationId;

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <h1 style={bookingTitle}>
            Hi {hostName}
          </h1>
          <EmptySpace height={20} />
          <div>
            You have successfully confirmed the reservation for {guestName}.
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}><span style={fontWeightBold}>Reservation Details:</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Listing Name:</span> {listTitle}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Check-in:</span> {checkInDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Check-out:</span> {checkOutDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Guests:</span>  {guests}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Reservation ID:</span> {reservationId}</div>
          <div>
            <a href={itineraryURL} style={linkText}> View Itinerary</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingConfirmationHost;